var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-error-alt",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13414",
    "data-name": "Path 13414",
    d: "M22,14h1.6v5.6H22Zm0,6.4h1.6V22H22Z",
    transform: "translate(-10.8 -6)",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13415",
    "data-name": "Path 13415",
    d: "M19.766,8.234l-4-4A.8.8,0,0,0,15.2,4H8.8a.8.8,0,0,0-.566.234l-4,4A.8.8,0,0,0,4,8.8v6.4a.8.8,0,0,0,.234.566l4,4A.8.8,0,0,0,8.8,20h6.4a.8.8,0,0,0,.566-.234l4-4A.8.8,0,0,0,20,15.2V8.8a.8.8,0,0,0-.234-.566ZM18.4,14.869,14.869,18.4H9.131L5.6,14.869V9.131L9.131,5.6h5.738L18.4,9.131v5.738Z",
    transform: "translate(0)",
    fill: "#868a97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8c38f6f24c9dc865a00de2b5451162e6.svg";
export { ForwardRef as ReactComponent };